import React from 'react';
import {InputSignal} from '../bulk-override';
import {useAuth} from '../hooks/use-auth';
import {Notification} from '../navigation/page-layout';
import {OteExclusionManager} from '../ote-exclusions';

export function InputSignalsPage(props: {pushNotification: (notification: Notification) => void}) {
    const auth = useAuth();
    const oteAnomalyDetectionEnabled = auth.authInformation!.current!.configurationData?.oteAnomalyDetectionEnabled ?? false;

    // Pass the exclusion controls in as an extra template column so they line up with Percentage
    // Adjustment instead of being stacked underneath it.
    const additionalTemplateSections = oteAnomalyDetectionEnabled
        ? [<OteExclusionManager key="ote-exclusions" pushNotification={props.pushNotification} />]
        : [];

    return <InputSignal pushNotification={props.pushNotification} additionalTemplateSections={additionalTemplateSections} />;
}
